import { useQuery } from '@tanstack/react-query';
import { Row, Col, Card, Statistic, Table, Tag, Space, Spin, Alert, DatePicker, Select, Tooltip } from 'antd';
import {
    DollarOutlined,
    ShoppingCartOutlined,
    WarningOutlined,
    CheckCircleOutlined,
    RiseOutlined,
    FallOutlined,
    ClockCircleOutlined,
    InboxOutlined,
    ExclamationCircleOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { dashboardApi, inventoryApi, ordersApi, productsApi } from '../../api/client';
import dayjs from 'dayjs';
import { CompanyDashboard } from './CompanyDashboard';

const { RangePicker } = DatePicker;

export default function DashboardPage() {
    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <CompanyDashboard />
        </Space>
    );
}
